import type { ReactNode } from 'react';

export default function Eyebrow({
  children,
  color = 'violet',
  className = '',
}: {
  children: ReactNode;
  color?: 'violet' | 'muted' | 'pink' | 'cyan';
  className?: string;
}) {
  const map = {
    violet: 'text-violet',
    muted: 'text-muted',
    pink: 'text-pinkMid',
    cyan: 'text-cyan-700',
  };
  return (
    <p className={`text-[11px] font-bold uppercase tracking-wider ${map[color]} ${className}`}>
      {children}
    </p>
  );
}
